export default function About() : JSX.Element {
	return (
		<h1>About</h1>
	);
}